<template>
  <div class=""> 
    <b-row>
        <b-col cols="12" lg="3" md="4" sm="12">
            <side-bar></side-bar>
        </b-col>
        <b-col cols="12" lg="9" md="8" sm="12" >
            <div class="content mt-5">
                <literature-intro></literature-intro>
            </div>    
        </b-col>
    </b-row>

  </div>
</template>
<script>
import SideBar from "./base/SideBar"
import LiteratureIntro from "./LiteratureIntro"
export default {
  components:{
      SideBar,
      LiteratureIntro
  },
  data () {
      return {
      }
  },
  methods:{

  },
}
</script>
<style scoped>
/* .content {
    line-height: 2em;
    color: black;
    text-align:justify
} */

</style>



